/***
**Module Name: About Us
 **File Name :  AboutUS.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains About us details.
 ***/
import React, { useState, useEffect, useContext } from "react";

// import "../../src/assets/css/style.css"
import tmdbApi from "../api/tmdbApi";
import InsideHeader from "../components/InnerHeader/Header";
import Footer from "../components/footer/Footer";
import Modal from 'react-bootstrap/Modal';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import $ from 'jquery';
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import * as Config from "../constants/Config";
import { useNavigate, useLocation } from "react-router";
import { contentContext } from "../context/contentContext";
import EnquiryForm from "./EnquiryForm"
import SessionPopup from "./SessionPopup"
import Select from 'react-select';
import moment from "moment";
import CurrencyInput from 'react-currency-input-field';

import InactivePopup from "./inactivePopup";
// import { set } from "video.js/dist/types/tech/middleware";
const Cart = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const fromEmail = params.get("from") === "email";
    // const [menus, setMenus] = useState([]);
    const [show, setShow] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isLoadCart, setIsLoadCart] = useState(false);
    const [config, setConfig] = useState({});
    const [selectedId, setSelectedId] = useState("");
    const [enquire, setEnquire] = useState(false);
    // const [enqFormValues, SetEnqFormValues] = useState([]);
    const [isEnquireSuccess, setIsEnquireSuccess] = useState(false);
    const [isLoad1, setIsLoad1] = useState(false);
    const [progressBarActive, SetProgressBarActive] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [perPageConst, setPerPageConst] = useState(10);
    const [perpage, setPerpage] = useState(10);
    const [assetTotal, setAssetTotal] = useState(0);
    const [deleteType, setDeleteType] = useState("single");
    const [activeCheckId, setActiveCheckId] = useState("");
    const [rightsData, setRightsData] = useState({});

    // const [progress, setProgress] = useState(0);

    const [totalPages, setTotalPages] = useState(0);
    const [totalPagesArray, setTotalPagesArray] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [activeLoad, setActiveLoad] = useState("");

    console.log("fromEmail", fromEmail)
    const [Regions, setRegions] = useState([]);
    const [rightsAvailableError, setRightsAvailableError] = useState("");
    const [exclusivityError, setExclusivityError] = useState("");
    const [regionError, setRegionError] = useState("");
    const [dateError, setDateError] = useState("");
    const [videoformatData, setVideoformatData] = useState({});


    const [lookup, setLookUp] = useState({});

    const [languagesData, setlanguagesData] = useState({});
    const [countryData, setCountryData] = useState({});
    const [multiSelectFields, setMultiSelectFields] = useState({});
    const [enquiryFormValues, setEnquiryFormValues] = useState({});
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);

    const [alreadyItems, setAlreadyItems] = useState([]);
    const [generatedItems, setGeneratedItems] = useState([]);
    const exclusivityOptions = [
        { value: "", label: "Select" },
        { value: "Exclusive", label: "Exclusive" },
        { value: "Non-Exclusive", label: "Non-Exclusive" },
    ];


    let { lambda, appname } = window.app;
    const { clientData, inactiveFlag, setInactiveFlag, enqFormValues, setShowCategoryData, SetEnqFormValues, wishListData, progress, setProgress, setWishListData, wishlistCount, prevRoute, route, setwishlistCount, menus, setContentSearchFlag, contentSearchFlag, setRoute } = useContext(contentContext)
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }

        getWishlistFun();
        clientActivity();

    }, [perpage, pageNumber]);

    useEffect(() => {
        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);

    if (config.common && config.common.imagesCDN) {
        var img = config.common.imagesCDN;
    }

    const AddNotify = () => toast.success('Your enquiry has been sent', {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    },)
    const ShowError = () => toast.error('Please select to add additional comments', {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    },)

    const clientActivity = () => {
        let path = window.location.pathname.split("/");

        var presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": 'CART',
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        let urlLink;
        if (localStorage.getItem("previousid")) {
            urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid")
        } else {
            urlLink = lambda + '/activity?appname=' + appname
        }

        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response.data.statusCode === 200) {
                    localStorage.setItem("previousid", response.data.result)
                }
            });
    }
    const getSelectedDate = (dateString) => {
        return dateString ? new Date(dateString) : null;
    };
    const getWishlistFun = async () => {
        try {
            setIsLoadCart(true)


            let payload = { perpage, pageNumber }
            const response = await tmdbApi.cartGetWishlist(payload);

            if (response.statusCode === 200) {
                if (response.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else if (response.result == "Client inactived") {
                    setInactiveFlag(true)

                } else {
                    let data = response.result && response.result && response.result.result ? response.result.result : []

                    if (data.length > 0) {
                        setWishListData(data)
                        let assetTotal = response.result.count || 0
                        setwishlistCount(assetTotal)
                        localStorage.setItem('wishlistCount', assetTotal)
                        setAssetTotal(assetTotal)

                        if (assetTotal > 0) {
                            let totalPages = assetTotal / perpage;
                            totalPages = Math.ceil(totalPages)
                            let totalArray = [];
                            for (var i = 0; i < totalPages; i++) {
                                totalArray.push(i + 1)
                            }
                            setTotalPagesArray(totalArray)
                            setTotalPages(totalPages)
                            // SetEnqFormValues([])
                        }
                    }
                    else {
                        setwishlistCount(0)
                        localStorage.setItem('wishlistCount', 0)
                        setWishListData([])
                        setIsLoadCart(false)
                    }
                }
                setActiveCheckId("")

            }
        } catch {
            setIsLoadCart(false)
            setActiveCheckId("")
            console.log("error");
        }

    }
    console.log('contentSearchFlag', contentSearchFlag)
    console.log("multiSelectFieldssssssssss", multiSelectFields)
    const handleChangeDelete = (item, check) => {
        setIsDelete(true)
        setDeleteType("single")
        setSelectedId(item.contentid)


    }
    const handleDeleteAll = (deleteid) => {
        setIsDelete(true)

        setDeleteType("multiple")


    }

    const deleteWishlistFun = async (payload, isSubmit, alreadyItems) => {

        const allTitles = enqFormValues?.filter(item => item?.title)?.map(item => item.title)
        try {
            console.log('payload delete wishlist', payload)
            setIsLoadCart(true)
            const requestData = {
                contentid: payload,
                ...(isSubmit !== "submit" && {
                    activity: {
                        pageVisited: "Cart",
                        action: "Removed from cart",
                        time: moment().format("hh:mm A"),
                        actionDescription: allTitles,
                        icon: "shopping_cart"
                    }
                })
            };
            const clientid = localStorage.getItem("clientid")

            axios({
                method: 'DELETE',
                url: lambda + "/wishlist?appname=" + appname + "&clientid=" + clientid + '&token=' + localStorage.getItem("token"),
                data: requestData
            })
                .then(function (response) {
                    console.log('response result------------------->', response)
                    if (response.data.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setIsLoadCart(false)
                        SetProgressBarActive(false)
                    } else if (response.data.result == "Client inactived") {
                        setInactiveFlag(true)
                        setIsLoadCart(false)
                        SetProgressBarActive(false)
                    } else {
                        //  getWishlistFun()

                        if (isSubmit != "submit") {
                            RemoveNotify()
                        }
                        setIsLoadCart(false)
                        SetProgressBarActive(false)
                        // Only clear enquiry form if NO already-existing items
                        if (!alreadyItems || alreadyItems.length === 0) {
                            SetEnqFormValues([]);
                        }
                        if (pageNumber !== 1) {
                            setPageNumber(1)
                            setPerpage(10)
                        }
                        else {
                            getWishlistFun()
                        }
                    }
                });



        } catch {
            setIsLoadCart(false)
            console.log("error");
        }

    }
    const RemoveNotify = () => toast.success('Removed from Cart', {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
    },)

    function onConfirm() {
        if (deleteType == "single") {
            setActiveCheckId(selectedId)
            let payload = [selectedId]

            deleteWishlistFun(payload)
        } else if (deleteType == "multiple") {
            setActiveCheckId("multiple")
            const payload = enqFormValues.map((eachItem) => {
                return eachItem.contentid
            })
            console.log("payload deleteeee", payload)
            deleteWishlistFun(payload)
        }

        setIsDelete(false)
        SetProgressBarActive(true)
    };
    function onCancel() {
        setIsDelete(false)
    }

    const handleCloseEnq = () => {
        console.log(enquire)
        setEnquiryFormValues([])
        setMultiSelectFields([])
        setRightsAvailableError("")
        setExclusivityError("")
        setRegionError("")
        setDateError("")
        setShow(false)
    };

    const handleChangeCheckItem = (e, item) => {


        const clientid = localStorage.getItem("clientid")

        if (e.target.checked == true) {

            let arr = [...enqFormValues]
            let defaultImg = `${img}orasi/common/images/img-default.jpg`;

            let imgKey = item.portraitimage != undefined && item.portraitimage != "" ? "portraitimage" :
                item.landscapeimage != undefined && item.landscapeimage != "" ? "landscapeimage"
                    : "defaultImg"

            let imgValue = item.portraitimage != undefined && item.portraitimage != "" ? item.portraitimage :
                item.landscapeimage != undefined && item.landscapeimage != "" ? item.landscapeimage
                    : defaultImg

            const newObj = {
                clientid: clientid,
                appname: item.appname,
                title: item.title,
                contentid: item.contentid,
                comments: "",

                [imgKey]: imgValue,

                category: item.category,
                companyid: item.companyid
            }
            arr.push(newObj)
            SetEnqFormValues(arr)
        }
        else {
            let newArr = [...enqFormValues]
            let resultArray = newArr.filter((eachitem) => eachitem.contentid !== item.contentid)
            SetEnqFormValues(resultArray)
        }

    }
    const handleSelectAll = (e) => {


        const clientid = localStorage.getItem("clientid")

        if (e.target.checked == true) {

            let arr = []
            let tempWishListData = wishListData

            tempWishListData && tempWishListData.length > 0 && tempWishListData.map((item) => {
                let defaultImg = `${img}orasi/common/images/img-default.jpg`;

                let imgKey = item.portraitimage != undefined && item.portraitimage != "" ? "portraitimage" :
                    item.landscapeimage != undefined && item.landscapeimage != "" ? "landscapeimage"
                        : "defaultImg"

                let imgValue = item.portraitimage != undefined && item.portraitimage != "" ? item.portraitimage :
                    item.landscapeimage != undefined && item.landscapeimage != "" ? item.landscapeimage
                        : defaultImg

                const newObj = {
                    clientid: clientid,
                    appname: item.appname,
                    title: item.title,
                    contentid: item.contentid,
                    // thumbnail: item.thumbnail,
                    [imgKey]: imgValue,

                    category: item.category,
                    companyid: item.companyid
                }
                arr.push(newObj)
                SetEnqFormValues(arr)


            })


        }
        else {

            SetEnqFormValues([])
        }

    }
    console.log('enqFormValues in cart page', enqFormValues)

    const handleChangePages = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name == 'perPage') {
            setPageNumber(1)
            setPerpage(value)
        }
        if (name == 'pageNo') {
            setPageNumber(value)
        }
    }
    const previousClick = (e) => {
        e.preventDefault()
        let k = parseInt(pageNumber)

        setPageNumber(k - 1)
    }
    const nextClick = (e) => {
        e.preventDefault()
        let k = parseInt(pageNumber)
        setPageNumber(k + 1)
    }

    const handleItem = (checkItem) => {
        if (checkItem === false) {
            // ShowError()
        }
    }
    console.log('enqFormValues', enqFormValues)

    const handleAddComments = (e, item) => {

        let value = e.target.value
        // console.log('item.contenid', item.contentid)
        // console.log('value', e.target.value)
        // console.log('form values incomments ', enqFormValues)
        let updatedArr = enqFormValues.map((eachItemm) => {
            if (eachItemm.contentid === item.contentid) {
                return { ...eachItemm, "comments": value }
            }
            return eachItemm
        })

        // console.log('updatedArr ', updatedArr)
        SetEnqFormValues(updatedArr)
        //         updatedArr
        //     });
        //    SetEnqFormValues({...updatedArr,["comments"]:value});
        //    return {...each ,"comments": value}
    }

    const handleBack = () => {
        navigate('/content')
    }

    const handleExplore = () => {
        setShowCategoryData(true)
        navigate('/content')
    }


    const submitForm = (e) => {
        // console.log('submit clicked')
        const isValid = formvalidation();
        if (isValid) {
            if (activeLoad == "") {
                submitEnquiryFun();
            }
        }
        // }

    }
    const handleRightsavailableError = () => {
        setRightsAvailableError("")
    }
    console.log('enquiryFormValues', enquiryFormValues)
    function formvalidation() {
        let formIsValid = true;

        // Validate rightsAvailable (multi-select)
        if (!multiSelectFields?.rightsAvailable?.length) {
            setRightsAvailableError("Please enter rights available");
            formIsValid = false;
        } else {
            setRightsAvailableError("");
        }
        // Validate exclusivity
        // if (!enquiryFormValues?.exclusivity?.trim()) {
        //     setExclusivityError("Please select exclusivity");
        //     formIsValid = false;
        // } else {
        //     setExclusivityError("");
        // }


        if (!multiSelectFields?.regions?.length) {
            setRegionError("Please select regions");
            formIsValid = false;
        } else {
            setRegionError("");
        }

        // Validate date range only if both dates exist
        if (
            enquiryFormValues?.rightsAvailableFromDate &&
            enquiryFormValues?.rightsAvailableToDate &&
            enquiryFormValues.rightsAvailableToDate < enquiryFormValues.rightsAvailableFromDate
        ) {
            setDateError("To date cannot be earlier than From date");
            formIsValid = false;
        } else {
            setDateError("");
        }

        return formIsValid;
    }


    console.log('enqFormValues before submit', enqFormValues)
    const submitEnquiryFun = async () => {
        const allTitles = enqFormValues
            ?.filter(item => item?.title)
            ?.map(item => item.title);

        try {
            setActiveLoad("enquire");

            const clientid = localStorage.getItem("clientid");
            var time = moment().format("hh:mm A");

            const response = await tmdbApi.submitEnquiry({
                clientid: clientid ?? "",
                companyid: clientData?.companyid ?? "",
                rightsAvailable: multiSelectFields?.rightsAvailable ?? "",
                comments: enquiryFormValues?.additionalCom ?? "",
                request: enquiryFormValues?.request ?? "",
                requiredtodate: enquiryFormValues?.rightsAvailableToDate ?? "",
                requiredfromdate: enquiryFormValues?.rightsAvailableFromDate ?? "",
                videoformatsrequired: multiSelectFields?.videoformat ?? "",
                dubbinglanguagesrequired: multiSelectFields?.dubbinglanguages ?? "",
                exclusive: enquiryFormValues.exclusivity ?? "",
                totalbudget: enquiryFormValues?.totalbudget ?? "",
                queries: enquiryFormValues?.queries ?? "",
                regionsrequired: multiSelectFields?.regions ?? "",
                content: enqFormValues,
                activity: {
                    pageVisited: "Cart",
                    action: "Enquiry",
                    time: time,
                    actionDescription: allTitles,
                    icon: "shopping_cart"
                }
            });

            const result = response?.result || "";
            const hasAlready = result.includes("Enquiry already exists for:");
            const hasGenerated = result.includes("Enquiry generated for:");

            let alreadyList = [];
            let generatedList = [];

            if (response.statusCode === 200) {

                // Session expired
                if (result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);

                    // Client inactive
                } else if (result === "Client inactived") {
                    setInactiveFlag(true);

                    // BOTH: already exists + generated
                } else if (hasAlready && hasGenerated) {

                    const alreadyMatch = result.match(/Enquiry already exists for:\s*(.*?)(\n|$)/);
                    if (alreadyMatch && alreadyMatch[1]) {
                        alreadyList = alreadyMatch[1].replace('.', '').split(',').map(i => i.trim());
                    }

                    const generatedMatch = result.match(/Enquiry generated for:\s*(.*)/);
                    if (generatedMatch && generatedMatch[1]) {
                        generatedList = generatedMatch[1].replace('.', '').split(',').map(i => i.trim());
                    }


                    setAlreadyItems(alreadyList);
                    setGeneratedItems(generatedList);
                    setShowEnquiryModal(true);

                    const alreadyExistItems = enqFormValues.filter(item =>
                        alreadyList.some(already =>
                            already.trim().toLowerCase() === item.title.trim().toLowerCase()
                        )
                    );

                    // UI shows only already-exist items
                    SetEnqFormValues(alreadyExistItems);
                    const generatedItems = enqFormValues.filter(item =>
                        !alreadyList.some(already =>
                            already.trim().toLowerCase() === item.title.trim().toLowerCase()
                        )
                    );

                    const payload = generatedItems.map(item => item.contentid);

                    // now safe

                    deleteWishlistFun(payload, "submit", alreadyList);




                    // ONLY already exists
                } else if (hasAlready) {

                    const match = result.match(/Enquiry already exists for:\s*(.*?)(\n|$)/);
                    if (match && match[1]) {
                        alreadyList = match[1].replace('.', '').split(',').map(i => i.trim());
                    }


                    setAlreadyItems(alreadyList);
                    setGeneratedItems([]);
                    setShowEnquiryModal(true);

                    // ONLY generated
                }
                // else if (hasGenerated) {

                //     const match = result.match(/Enquiry generated for:\s*(.*)/);
                //     if (match && match[1]) {
                //         generatedList = match[1].replace('.', '').split(',').map(i => i.trim());
                //     }


                //     setGeneratedItems(generatedList);
                //     setAlreadyItems([]);
                //     setShowEnquiryModal(true);

                //     const payload = enqFormValues.map(eachItem => eachItem.contentid);
                //     // deleteWishlistFun(payload, "submit");

                //     setEnquiryFormValues([]);
                //     SetEnqFormValues([]);
                //     setMultiSelectFields([]);
                //     handleCloseEnq();

                //     // Normal success
                // } 
                else {
                    const payload = enqFormValues.map(eachItem => eachItem.contentid);
                    deleteWishlistFun(payload, "submit");

                    setEnquiryFormValues([]);
                    SetEnqFormValues([]);
                    setMultiSelectFields([]);

                    AddNotify();
                    handleCloseEnq();
                }

                setActiveLoad("");
            }

        } catch {
            setActiveLoad("");
            console.log("error");
        }
    };

    useEffect(() => {
        if (fromEmail) {
            localStorage.setItem("comingFromEmail", "emailCart"); // string instead of true
        } else {
            localStorage.removeItem("comingFromEmail");
        }

        GetLookUp();
        setContentSearchFlag(false)
        setRoute("notcontent")

    }, []);
    // console.log('multiselect fielsd',multiSelectFields)
    const GetLookUp = async (e) => {
        try {
            let arrayType = ["videoformat", "language", "territories", "rights"];

            const response = await tmdbApi.getLookUp({
                type: arrayType,
                "sortBy": "name"

            });
            console.log(response);
            if (response.statusCode == 200) {
                let arrayType = ["videoformat", "language", "territories", "rights"];
                let lookupsData = response.result || []
                arrayType?.map((eachItem) => {
                    let arr1 = []
                    lookupsData?.map((item1) => {
                        if (item1.type == eachItem) {
                            arr1.push(item1.name)
                        }
                    });
                    lookup[eachItem] = arr1
                    setLookUp({ ...lookup });
                })
                console.log('loookup', lookup)
                const territoriesObj = prepareObject(lookup?.territories)
                setCountryData(territoriesObj)
                const languagesObj = prepareObject(lookup?.language)
                setlanguagesData(languagesObj)
                const videoformatObj = prepareObject(lookup?.videoformat)
                setVideoformatData(videoformatObj)
                const rightsObj = prepareObject(lookup?.rights)
                setRightsData(rightsObj)

            }

        } catch {
            console.log("error");
        }
    }
    const prepareObject = (item) => {
        const resultArr = item?.map((eachItem) => { return { value: eachItem, label: eachItem }; })
        return resultArr
    }

    // const handleMultiSelect = (selected, key) => {
    //     let selectedArray = returnArray(selected)
    //     setMultiSelectFields({ ...multiSelectFields, [key]: selectedArray })
    //     setRightsAvailableError("")
    // };
    const handleMultiSelect = (selected, key) => {
        // Convert selected objects from React Select to an array of strings
        const selectedArray = selected?.map(item => item.value) || [];

        setMultiSelectFields(prev => ({
            ...prev,
            [key]: selectedArray
        }));

        // Clear error dynamically for the field
        if (key === "rightsAvailable") setRightsAvailableError("");
        if (key === "regions") setRegionError("");
        // Add other multi-select fields as needed
    };

    const returnArray = (arr) => {
        let newArr = []
        arr.map((eachItem) => {
            newArr.push(eachItem?.value)
        })

        return newArr
    }
    const handleEnquireForm = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (e.target.name == "rightsavailabletodate" || e.target.name == "rightsavailablefromdate") {
            let date = moment(new Date(value)).toISOString();
            setEnquiryFormValues({ ...enquiryFormValues, [name]: date });
        } else if (e.target.name == "rightsAvailable") {
            setEnquiryFormValues({ ...enquiryFormValues, [name]: value })
            setRightsAvailableError("")
        } else if (e.target.name == "exclusivity") {
            setEnquiryFormValues({ ...enquiryFormValues, [name]: value })
            setExclusivityError("")
        } else {
            setDateError("")
            setEnquiryFormValues({ ...enquiryFormValues, [name]: value })
        }

    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: "#111111",
            borderColor: "#2c2c2c",
            boxShadow: "none",
            "&:hover": { borderColor: "#2c2c2c" },
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: "#292929", // menu background
        }),

        menuList: (provided) => ({
            ...provided,
            backgroundColor: "#292929", // list background
        }),
        menu: (provided) => ({
            ...provided,
            // keep default scroll and dropdown behavior
        }),
        // no need to override indicators or other components
        dropdownIndicator: (provided) => ({
            ...provided,
            color: "rgb(104, 104, 104)",           // change indicator (arrow) color
            "&:hover": { color: "rgb(104, 104, 104)" },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#020202 !important", // keep chip dark
            border: "1px solid #444444",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#ffffff",
            backgroundColor: "#020202",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#ffffff",
            fontSize: "12px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "#ffffff",
            backgroundColor: "#020202",
            cursor: "pointer",
            ":hover": {
                backgroundColor: "#020202",
                color: "#ffffff",
            },
        }),
    };

    const handleChange = (selectedOption) => {
        handleEnquireForm({
            target: { name: "exclusivity", value: selectedOption.value },
        });
    };
    return (
        <>
            {inactiveFlag && <InactivePopup />}
            {!inactiveFlag && showSessionPopupup && <SessionPopup />}

            {/* {showSessionPopupup && <SessionPopup />} */}
            <Modal className="access-denied" show={isDelete} id="modalDeleteConfirm">

                <div className="modal-body enquiry-form">
                    <div className="container">

                        <button className="close-btn" id="btnDeleteModalClose" onClick={e => onCancel()}>
                            <span className="material-icons">close</span>
                        </button>

                        <span className="material-icons access-denied-icon" id="iconDeleteModal">delete_outline</span>

                        <h3 id="deleteModalTitle">Remove</h3>

                        <p id="deleteModalInfo1">This action cannot be undone.</p>

                        <p id="deleteModalInfo2">
                            Are you sure you want to remove{`${deleteType == 'multiple' ? ' selected items' : ''}`}?
                        </p>

                        <button
                            className="fill_btn yellow-gradient"
                            id="btnDeleteConfirm"
                            data-bs-toggle="modal"
                            data-bs-target="#recommendModal"
                            onClick={e => onConfirm()}
                        >
                            Yes, Remove
                        </button>

                    </div>
                </div>

            </Modal>

            <Modal show={show} id="modalEnquiryForm">

                <div className="modal-header" id="enquiryHeader">
                    <img
                        src={img + Config.imgmiddle + "logo_white.png"}
                        alt=""
                        className="modal-logo"
                        id="enquiryLogo"
                    />
                    <h4 className="modal-title pos-center" id="enquiryTitle">Enquiry Form</h4>

                    <a
                        href="#"
                        className="btn-close"
                        id="btnEnquiryClose"
                        data-bs-dismiss="modal"
                        onClick={handleCloseEnq}
                        style={{ cursor: "pointer", textDecoration: "none" }}
                    >
                        <span className="material-symbols-outlined">close</span>
                    </a>
                </div>

                <div className="modal-body enquiry-form" id="enquiryBody">
                    <div className="container">
                        <div className="row">

                            <h6 id="selectedTitlesCount">
                                {enqFormValues?.length > 0 ? enqFormValues.length : 0}
                                {enqFormValues?.length == 1 ? " Title" : " Titles"} Selected
                            </h6>

                            {/* COMMENTS */}

                            <div className="col-md-12 col-lg-12">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Comments</label>

                                    <textarea
                                        id="inputComments"
                                        name="additionalCom"
                                        placeholder="Enter Comments"
                                        type="text"
                                        className="form-control"
                                        spellCheck="false"
                                        value={enquiryFormValues.additionalCom}
                                        onChange={(e) => handleEnquireForm(e)}
                                    ></textarea>

                                </div>
                            </div>

                            {/* REQUIRED RIGHTS */}

                            <div className="col-md-12 col-lg-12">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Required Rights <span>*</span></label>

                                    <Select
                                        id="selectRequiredRights"
                                        isMulti={true}
                                        placeholder='Required Rights'
                                        onChange={(selected) => handleMultiSelect(selected, "rightsAvailable")}
                                        options={rightsData}
                                        value={multiSelectFields?.rightsAvailable?.map(item => ({ value: item, label: item })) || []}
                                        isClearable={true}
                                        styles={customStyles}
                                    />

                                </div>

                                <span className="errormsg" id="errorRequiredRights" style={{ fontWeight: 'bold' }}>
                                    {rightsAvailableError}
                                </span>
                            </div>

                            {/* RIGHTS AVAILABLE FROM */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">
                                        Required rights available from
                                    </label>

                                    <DatePicker
                                        id="rightsAvailableFromDate"
                                        name="rightsAvailableFromDate"
                                        selected={getSelectedDate(enquiryFormValues?.rightsAvailableFromDate)}
                                        onChange={(date) => {
                                            handleEnquireForm({
                                                target: {
                                                    name: "rightsAvailableFromDate",
                                                    value: date ? date.toISOString().split("T")[0] : "",
                                                },
                                            });
                                        }}
                                        placeholderText="dd-mm-yyyy"
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control custom-datepicker-input"
                                        isClearable
                                    />

                                </div>
                            </div>

                            {/* RIGHTS AVAILABLE TO */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Required rights available to</label>

                                    <DatePicker
                                        id="rightsAvailableToDate"
                                        name="rightsAvailableToDate"
                                        selected={getSelectedDate(enquiryFormValues?.rightsAvailableToDate)}
                                        onChange={(date) => {
                                            handleEnquireForm({
                                                target: {
                                                    name: "rightsAvailableToDate",
                                                    value: date ? date.toISOString().split("T")[0] : "",
                                                },
                                            });
                                        }}
                                        placeholderText="dd-mm-yyyy"
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control custom-datepicker-input"
                                        isClearable
                                    />

                                </div>
                            </div>

                            {/* EXCLUSIVITY */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2 excl-select">
                                    <label className="col-form-label">Exclusivity</label>

                                    <Select
                                        id="selectExclusivity"
                                        value={exclusivityOptions.find((option) => option.value === enquiryFormValues.exclusivity)}
                                        onChange={handleChange}
                                        options={exclusivityOptions}
                                        styles={customStyles}
                                        isMulti={false}
                                        placeholder="Select Exclusivity"
                                    />

                                </div>
                            </div>

                            {/* REGIONS */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Regions <span>*</span></label>

                                    <Select
                                        id="selectRegions"
                                        isMulti={true}
                                        placeholder='Regions'
                                        onChange={(e) => handleMultiSelect(e, 'regions')}
                                        options={countryData}
                                        value={multiSelectFields?.regions?.map(item => ({ value: item, label: item })) || []}
                                        styles={customStyles}
                                    />

                                </div>

                                <span className="errormsg" id="errorRegions" style={{ fontWeight: 'bold' }}>
                                    {regionError}
                                </span>
                            </div>

                            {/* DUBBING LANGUAGES */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Dubbing Languages</label>

                                    <Select
                                        id="selectDubbingLanguages"
                                        isMulti={true}
                                        placeholder='Dubbing Languages'
                                        onChange={(e) => handleMultiSelect(e, 'dubbinglanguages')}
                                        options={languagesData}
                                        value={multiSelectFields?.dubbinglanguages?.map(eachItem => ({ value: eachItem, label: eachItem })) || []}
                                        styles={customStyles}
                                    />

                                </div>
                            </div>

                            {/* VIDEO QUALITY */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Video Quality</label>

                                    <Select
                                        id="selectVideoQuality"
                                        isMulti={true}
                                        placeholder='Video quality'
                                        onChange={(e) => handleMultiSelect(e, 'videoformat')}
                                        options={videoformatData}
                                        value={multiSelectFields?.videoformat?.map(eachItem => ({ value: eachItem, label: eachItem })) || []}
                                        isClearable={true}
                                        styles={customStyles}
                                    />

                                </div>
                            </div>

                            {/* SPECIAL REQUEST */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Special Request</label>

                                    <textarea
                                        id="inputSpecialRequest"
                                        name="request"
                                        placeholder="Enter Special Request"
                                        className="form-control"
                                        spellCheck="false"
                                        value={enquiryFormValues.request}
                                        onChange={(e) => handleEnquireForm(e)}
                                    ></textarea>
                                </div>
                            </div>

                            {/* QUERY */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">
                                    <label className="col-form-label">Enter Query</label>

                                    <textarea
                                        id="inputQuery"
                                        name="queries"
                                        placeholder="Enter Query"
                                        className="form-control"
                                        spellCheck="false"
                                        value={enquiryFormValues.queries}
                                        onChange={(e) => handleEnquireForm(e)}
                                    ></textarea>
                                </div>
                            </div>

                            {/* TOTAL BUDGET */}

                            <div className="col-md-6 col-lg-6">
                                <div className="form-group mb-2">

                                    <label className="col-form-label">Total Budget (USD)</label>

                                    <CurrencyInput
                                        id="inputTotalBudget"
                                        name="totalbudget"
                                        className="form-control"
                                        placeholder="Enter Total Budget"
                                        defaultValue={enquiryFormValues?.totalbudget}
                                        decimalsLimit={2}
                                        prefix="$"
                                        onValueChange={(value, name, values) => {
                                            setEnquiryFormValues({ ...enquiryFormValues, [name]: values?.value })
                                        }}
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="modal-footer" id="enquiryFooter">
                    <button
                        className="fill_btn yellow-gradient float-end"
                        id="btnSubmitEnquiry"
                        onClick={(e) => submitForm(e)}
                    >
                        {activeLoad === "enquire" ? (
                            <img
                                src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                                className="loading-icon"
                            />
                        ) : null}

                        Submit
                    </button>

                    <div className="clearfix"></div>
                </div>

            </Modal>
            <InsideHeader activeClass={"0"} />

            <div className="inner-body cart" id="cartPage">
                <div className="body-header">
                    <div className="md-container">
                        <div className="page-header">
                            <div className="title-wrapper">
                                <div className="block-title">
                                    <h2 id="cartHeaderTitle">Cart</h2>
                                </div>
                                <div className="title-action">
                                    {enqFormValues && enqFormValues?.length >= 1 ? (
                                        <button
                                            className="plain-btn color-btn"
                                            id="btnRemoveSelected"
                                            onClick={handleDeleteAll}
                                            disabled={enqFormValues && enqFormValues.length <= 0}
                                        >
                                            {activeCheckId === "multiple" ? (
                                                <img
                                                    src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                                                    className="loading-icon"
                                                />
                                            ) : (
                                                <span className="material-icons-outlined plus">delete</span>
                                            )}
                                            Remove Selected
                                        </button>
                                    ) : null}
                                </div>
                            </div>

                            <button className="plain-btn" id="btnBackToPage" onClick={handleBack}>
                                <span className="material-icons-outlined">chevron_left</span>Back
                            </button>
                        </div>
                    </div>
                </div>

                {wishListData && wishListData.length > 0 ? (
                    <>
                        <div className="body-content mt-3">
                            <div className="md-container">
                                <div className="cart-block mb-3">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <th>
                                                        <input
                                                            type="checkbox"
                                                            id="chkSelectAll"
                                                            checked={enqFormValues.length === wishListData.length}
                                                            onChange={(e) => handleSelectAll(e)}
                                                        />
                                                    </th>
                                                </th>
                                                <th>Title</th>
                                                <th>Additional Comments</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {wishListData?.map((item, i) => {

                                                let picName = item?.mediaType === 'video' ? 'videoclip-defaulr' :
                                                    item?.mediaType === 'audio' ? 'musicfile-default' :
                                                        item?.mediaType === 'pdf' ? 'pdf-default' :
                                                            item?.mediaType === 'doc' ? 'doc-defaulr' :
                                                                'img-default';

                                                let defaultImg = `${img}orasi/common/images/img-default.jpg`;

                                                let imgUrl =
                                                    item?.portraitimage !== "" && item?.portraitimage !== undefined
                                                        ? (item?.portraitimage.startsWith("http") ? item?.portraitimage : img + item?.portraitimage)
                                                        : item?.landscapeimage !== "" && item?.landscapeimage !== undefined
                                                            ? (item?.landscapeimage.startsWith("http") ? item?.landscapeimage : img + item?.landscapeimage)
                                                            : defaultImg;

                                                let filterList = enqFormValues.filter((eachitem) => eachitem?.contentid === item?.contentid);
                                                let isCheck = filterList && filterList[0] && filterList[0]?.title ? true : false;

                                                return (
                                                    <tr key={i} id={`cartRow_${item?.contentid}`}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                id={`chkItem_${item?.contentid}`}
                                                                checked={isCheck}
                                                                onChange={(e) => handleChangeCheckItem(e, item)}
                                                            />
                                                        </td>

                                                        <td>
                                                            <div className="cart-title-block">
                                                                <div className="cart-thumb me-3">
                                                                    <img src={imgUrl + "?auto=compress,format"} id={`itemImg_${item?.contentid}`} />
                                                                </div>
                                                                <div className="cart-title">
                                                                    <h6 id={`itemTitle_${item?.contentid}`}>{item?.title}</h6>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td onClick={(e) => handleItem(isCheck)}>
                                                            <textarea
                                                                id={`txtComment_${item?.contentid}`}
                                                                value={enqFormValues?.[i]?.comments ? enqFormValues?.comments : ''}
                                                                className="comments_area"
                                                                placeholder="Add additional comments"
                                                                disabled={!isCheck}
                                                                onChange={(e) => handleAddComments(e, item)}
                                                                type="text"
                                                            ></textarea>
                                                        </td>

                                                        <td>
                                                            <div className="table-actions-group">
                                                                <button
                                                                    className="table-actions-btn delete-btn"
                                                                    id={`btnDelete_${item?.contentid}`}
                                                                    onClick={(e) => handleChangeDelete(item, false)}
                                                                >
                                                                    {activeCheckId === item?.contentid ? (
                                                                        <img
                                                                            src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                                                                            className="loading-icon"
                                                                        />
                                                                    ) : (
                                                                        <span className="material-symbols-outlined">delete</span>
                                                                    )}
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>

                                    <div className="cart-footer d-flex justify-content-between">
                                        <button
                                            className={`fill_btn yellow-gradient ${enqFormValues && enqFormValues?.length <= 0 ? 'disable' : ''}`}
                                            id="btnEnquire"
                                            data-bs-toggle="modal"
                                            data-bs-target="#recommendModal"
                                            disabled={enqFormValues && enqFormValues?.length <= 0}
                                            onClick={handleShow}
                                        >
                                            Enquire
                                        </button>
                                    </div>

                                </div>

                                {assetTotal > perPageConst ? (
                                    <div className="row pagenation pgn" id="paginationSection">
                                        <div className="pagenation-left d-flex align-items-center">
                                            <label id="lblShowing">
                                                Showing {(pageNumber * perpage) >= assetTotal ? assetTotal : (pageNumber * perpage)} of {assetTotal}
                                            </label>

                                            <div className="pagenation_page">
                                                <label>Page :</label>

                                                <select
                                                    className="form-control custom-select u-w60 custom-select-sm form-select-sm"
                                                    id="selectPageNumber"
                                                    value={pageNumber}
                                                    name="pageNo"
                                                    onChange={(e) => handleChangePages(e)}
                                                >
                                                    {totalPagesArray?.map((item, i) => (
                                                        <option key={i} value={item}>{item}</option>
                                                    ))}
                                                </select>

                                                <label><strong> of {totalPages}</strong></label>
                                            </div>
                                        </div>

                                        <div className="pagenation-right d-flex align-items-center">
                                            <div className="pagenation_perpage">
                                                <label>Per Page:</label>

                                                <select
                                                    className="form-control custom-select u-w60 custom-select-sm form-select-sm"
                                                    id="selectPerPage"
                                                    name="perPage"
                                                    value={perpage}
                                                    onChange={(e) => handleChangePages(e)}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={75}>75</option>
                                                    <option value={100}>100</option>
                                                </select>
                                            </div>

                                            <div className="pagenation-buttons d-flex align-items-center">
                                                <button
                                                    className="jr-btn btn-white btn btn-default btn-block"
                                                    id="btnPrevPage"
                                                    disabled={pageNumber == 1}
                                                    onClick={(e) => previousClick(e)}
                                                >
                                                    <span className="material-icons-outlined">chevron_left</span>
                                                </button>

                                                <button
                                                    className="jr-btn btn-white btn btn-default btn-block"
                                                    id="btnNextPage"
                                                    disabled={pageNumber == totalPages}
                                                    onClick={(e) => nextClick(e)}
                                                >
                                                    <span className="material-icons-outlined">navigate_next</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </>
                ) : isLoadCart ? (
                    <div className="orasi-preloader">
                        <img src="https://d2aif2zmoi437u.cloudfront.net/orasi/common/images/preloader.png" />
                    </div>
                ) : (
                    <div className="comingsoon-wrapper">
                        <div className="comingsoon-block">
                            <img src={img + "orasi/common/images/shopping-list.png"} />
                            <h6>Your Cart is empty!</h6>
                            <p>
                                Looks like you have not added anything to your cart.<br />
                                Go ahead and explore top categories.
                            </p>
                            <button
                                className="fill_btn yellow-gradient mt-2"
                                id="btnExploreNow"
                                onClick={handleExplore}
                            >
                                Explore Now
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <Modal className="access-denied cart-access-alert" show={showEnquiryModal}
                onHide={() => setShowEnquiryModal(false)} >

                <div className="modal-body enquiry-form">
                    <div className="container">

                        <span className="material-symbols-outlined access-denied-icon">info</span>

                        <h3>Items Already Exist</h3>
                        <p className="sub-head">Some items in your cart have already been enquired</p>

                        {alreadyItems.length > 0 && (
                            <ul className="movie-list">
                                {alreadyItems.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        )}


                        {generatedItems.length > 0 && (
                            <>
                                <p className="sub-head">The remaining items are new and have not been enquired yet</p>
                                <ul className="movie-list">
                                    {generatedItems.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                            </>
                        )}

                        <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={() => setShowEnquiryModal(false)}>Ok</button>

                    </div>
                </div>

            </Modal>
            <Footer menus={menus} />
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

        </>
    );
};

export default Cart;